<template>
  <div class="collapse navbar-collapse w-auto h-auto h-100" id="sidenav-collapse-main">
    <ul class="navbar-nav">
      <li class="nav-item">
        <sidenav-item url="/main" :class="getRoute() === 'main' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'صفحه اصلی' : 'Dashboard'">
          <template v-slot:icon>
            <i class="ni ni-tv-2 c-yellow-600 text-sm "></i>
          </template>
        </sidenav-item>
      </li>
      
      <li class="nav-item" v-if="getPermission(1010).view">
        <sidenav-item url="/companies" :class="isGroupRoute('companies') ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'مدیریت شرکت ها' : 'Companies management'">
          <template v-slot:icon>
            <i class="ni ni-building text-info text-sm"></i>
          </template>
        </sidenav-item>
      </li>
      
      <li class="nav-item" v-if="getPermission(1060).view | getPermission(1110).view">
        <sidenav-item url="/customers" :class="isGroupRoute('customers') ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'مدیریت مشتری ها' : 'Customers management'">
          <template v-slot:icon>
            <i class="ni ni-shop text-info text-sm"></i>
          </template>
        </sidenav-item>
      </li>
      
      <li class="nav-item"
        v-if="getPermission(1050).view | getPermission(1070).view | getPermission(1120).view
              | (!this.$store.state.currentUserInfo.isCompanyUser & this.$store.state.currentUserInfo.isAdmin)">
        <sidenav-item url="/users" :class="isGroupRoute('users') ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'مدیریت کاربران' : 'Users management'">
          <template v-slot:icon>
            <i class="ni ni-single-02 text-info text-sm"></i>
          </template>
        </sidenav-item>
      </li>
      
      <li class="nav-item" v-if="getPermission(1030).view | getPermission(1040).view | getPermission(1080).view | getPermission(1090).view">
        <sidenav-item url="/roles/0" :class="isGroupRoute('roles') ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'مدیریت نقش ها' : 'Roles management'">
          <template v-slot:icon>
            <i class="ni ni-key-25 text-info text-sm"></i>
          </template>
        </sidenav-item>
      </li>
      
      <li class="nav-item" v-if="getPermission(1020).view | getPermission(1100).view">
        <sidenav-item url="/sections/0" :class="isGroupRoute('sections') ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'مدیریت بخش ها' : 'Sections management'">
          <template v-slot:icon>
            <i class="ni ni-chart-pie-35 text-info text-sm"></i>
          </template>
        </sidenav-item>
      </li>
      
      <li class="nav-item" v-if="getPermission(1130).insert | !this.$store.state.currentUserInfo.isCompanyUser">
        <sidenav-item url="/submitTicket" :class="getRoute() === 'submitTicket' ? 'active' : ''" :navText="'ثبت تیکت'">
          <template v-slot:icon>
            <fa-icon icon="fas fa-marker" class="c-teal-500 text-sm " />
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="getPermission(1130).view | getPermission(1140).view | !this.$store.state.currentUserInfo.isCompanyUser">
        <sidenav-item url="/bookmarkedTickets" :class="getRoute() === 'bookmarkedTickets' ? 'active' : ''" :navText="'تیکت های نشان شده'">
          <template v-slot:icon>
            <fa-icon icon="fas fa-bookmark" class="c-teal-500 text-sm " />
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="getPermission(1130).view | getPermission(1140).view | !this.$store.state.currentUserInfo.isCompanyUser">
        <sidenav-item url="/myTickets" :class="getRoute() === 'myTickets' ? 'active' : ''" :navText="'تیکت های من'">
          <template v-slot:icon>
            <fa-icon icon="fas fa-ticket" class="c-teal-500 text-sm " />
          </template>
          <template v-slot:badge v-if="myTicketsNotifications?.length > 0">
            <span class="position-absolute top-10 start-100 translate-middle badge rounded-pill bg-danger">{{ myTicketsNotifications?.length }}</span>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="getPermission(1140).view">
        <sidenav-item url="/referredTickets" :class="getRoute() === 'referredTickets' ? 'active' : ''"
          :navText="'تیکت های ارجاعی'">
          <template v-slot:icon>
            <fa-icon icon="fas fa-tasks" class="c-teal-500 text-sm " />
          </template>
          <template v-slot:badge v-if="newReferralNotifications?.length > 0">
            <span class="position-absolute top-10 start-100 translate-middle badge rounded-pill bg-danger">{{ newReferralNotifications?.length }}</span>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item"
        v-if="getPermission(1150).view | (!this.$store.state.currentUserInfo.isCompanyUser & this.$store.state.currentUserInfo.isAdmin)">
        <sidenav-item url="/allTickets" :class="getRoute() === 'allTickets' ? 'active' : ''"
          :navText="'همه تیکت‌ها'">
          <template v-slot:icon>
            <fa-icon icon="fas fa-archive" class="c-teal-500 text-sm " />
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="getPermission(1150).view">
        <a data-bs-toggle="collapse" href="#reportGroup_menu" aria-controls="report_menu"
           :aria-expanded="isGroupRoute('report') ? 'true' : 'false'"
           :class="isGroupRoute('report') ? 'active' : 'collapsed'"
           class="nav-link">
          <div class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center">
            <fa-icon icon="fas fa-hdd" class="c-red-400 text-sm "></fa-icon>
          </div>
          <span class="nav-link-text ms-1">گزارشات</span>
        </a>
        <div class="collapse"
             :class="isGroupRoute('report') ? 'show' : ''"
             id="reportGroup_menu">
          <ul class="nav ms-4 pe-2 pt-1">
            <li class="nav-item" v-if="getPermission(1150).view">
              <sidenav-item url="/comprehensiveReport"
                            :class="getRoute() === 'comprehensiveReport' ? 'active' : ''"
                            :navText="'گزارش جامع'">
                <template v-slot:icon>
                  <fa-icon icon="fas fa-database" class="c-light-green-600 text-sm "></fa-icon>
                </template>
              </sidenav-item>
            </li>
          </ul>
        </div>
      </li>

      <div v-if="false">
      <!--<li class="nav-item">
        <a data-bs-toggle="collapse" href="#ticket_menu" aria-controls="ticket_menu"
           :aria-expanded="isGroupRoute('ticket') ? 'true' : 'false'"
           :class="isGroupRoute('ticket') ? 'active' : 'collapsed'"
           class="nav-link">
          <div class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center">
            <fa-icon icon="fas fa-ticket" class="c-blue-300 text-sm "></fa-icon>
          </div>
          <span class="nav-link-text ms-1">{{ this.$store.state.isRTL ? 'تیکت' : 'Ticket' }}</span>
        </a>
        <div class="collapse"
             :class="isGroupRoute('ticket') ? 'show' : ''"
             id="ticket_menu">
          <ul class="nav ms-4 pe-2 pt-1">-->

      <!--<li class="nav-item" v-if="havePermission(1002)">
          <sidenav-item url="/schoolActivity"
                        :class="getRoute() === 'schoolActivity' ? 'active' : ''"
                        :navText="'اطلاعات فعالیت ها'">
            <template v-slot:icon>
              <fa-icon icon="fas fa-user-md" class="c-teal-400 text-sm "></fa-icon>
            </template>
          </sidenav-item>
        </li>-->
      <!--</ul>
        </div>
      </li>-->


      <!--<li class="nav-item d-none" v-if="havePermThisGroup(900)">
        <sidenav-item url="/cartabel"
                      :class="getRoute() === 'Cartabel' ? 'active' : ''"
                      :navText="this.$store.state.isRTL ? 'تایید اطلاعات' : 'Confirm Document'">
          <template v-slot:icon>
            <i class="ni ni-check-bold c-yellow-800 text-sm "></i>
          </template>
        </sidenav-item>
      </li>
      <li class="nav-item" v-if="havePermThisGroup(100)">
        <a data-bs-toggle="collapse" href="#baseinformation_menu" aria-controls="baseinformation_menu"
           :aria-expanded="isGroupRoute('baseInfoGroup') ? 'true' : 'false'"
           :class="isGroupRoute('baseInfoGroup') ? 'active' : 'collapsed'"
           class="nav-link">
          <div class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center">
            <fa-icon icon="fas fa-database" class="c-green-300 text-sm "></fa-icon>
          </div>
          <span class="nav-link-text ms-1">مدیریت اطلاعات</span>
        </a>
        <div class="collapse"
             :class="isGroupRoute('school') ? 'show' : ''"
             id="baseinformation_menu">
          <ul class="nav ms-4 pe-2 pt-1">
            <li class="nav-item" v-if="havePermission(1001)">
              <sidenav-item url="/school"
                            :class="getRoute() === 'school' ? 'active' : ''"
                            :navText="'اطلاعات آموزشگاه ها'">
                <template v-slot:icon>
                  <fa-icon icon="fas fa-award" class="c-teal-500 text-sm " />
                </template>
              </sidenav-item>
            </li>
            <li class="nav-item" v-if="havePermission(1002)">
              <sidenav-item url="/schoolActivity"
                            :class="getRoute() === 'schoolActivity' ? 'active' : ''"
                            :navText="'اطلاعات فعالیت ها'">
                <template v-slot:icon>
                  <fa-icon icon="fas fa-user-md" class="c-teal-400 text-sm "></fa-icon>
                </template>
              </sidenav-item>
            </li>
          </ul>
        </div>
      </li>-->

      <!--گزارشات-->
      <!--<li class="nav-item d-none" v-if="havePermThisGroup(2000)">
        <a data-bs-toggle="collapse" href="#reportGroup_menu" aria-controls="report_menu"
           :aria-expanded="isGroupRoute('reportGroup') ? 'true' : 'false'"
           :class="isGroupRoute('reportGroup') ? 'active' : 'collapsed'"
           class="nav-link">
          <div class="icon icon-shape icon-sm text-center d-flex align-items-center justify-content-center">
            <fa-icon icon="fas fa-gears" class="c-red-400 text-sm "></fa-icon>
          </div>
          <span class="nav-link-text ms-1">گزارشات</span>
        </a>
        <div class="collapse"
             :class="isGroupRoute('reportGroup') ? 'show' : ''"
             id="reportGroup_menu">
          <ul class="nav ms-4 pe-2 pt-1">
            <li class="nav-item" v-if="havePermission(20001)">
              <sidenav-item url="/reportResultDoctor"
                            :class="getRoute() === 'reportResultDoctor' ? 'active' : ''"
                            :navText="'گزارش نهایی ریز پرداخت پزشکان'">
                <template v-slot:icon>
                  <fa-icon icon="fas fa-user-md" class="c-light-green-600 text-sm "></fa-icon>
                </template>
              </sidenav-item>
            </li>
          </ul>
        </div>
      </li>-->

      <!--<li class="mt-3 nav-item d-none hide hidden">
        <h6 v-if="this.$store.state.isRTL"
            class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6"
            :class="this.$store.state.isRTL ? 'me-4' : 'ms-2'">
          تنظیمات حساب کاربری
        </h6>
        <h6 v-else
            class="text-xs ps-4 text-uppercase font-weight-bolder opacity-6"
            :class="this.$store.state.isRTL ? 'me-4' : 'ms-2'">
          ACCOUNT PAGES
        </h6>
      </li>-->

      <!--<li class="nav-item">
        <sidenav-item url="/Profile"
                      :class="getRoute() === 'profile' ? 'active' : ''"
                      :navText="this.$store.state.isRTL ? 'پروفایل من' : 'My Profile'">
          <template v-slot:icon>
            <i class="ni ni-single-02 text-info text-sm "></i>
          </template>
        </sidenav-item>
      </li>-->
      </div>

      <li class="nav-item">
        <sidenav-item url="/signout" :class="getRoute() === 'profile' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'خروج' : 'exit'">
          <template v-slot:icon>
            <fa-icon icon="fas fa-sign-out-alt" class="text-danger text-sm"></fa-icon>
          </template>
        </sidenav-item>
      </li>
      <li v-if="false" class="nav-item">
        <sidenav-item url="/signin" :class="getRoute() === 'signin' ? 'active' : ''"
          :navText="this.$store.state.isRTL ? 'ورود' : 'Sign In'">
          <template v-slot:icon>
            <i class="ni ni-single-copy-04 text-danger text-sm "></i>
          </template>
        </sidenav-item>
      </li>
    </ul>
  </div>
  <div class="pt-3 mx-3 mt-3 sidenav-footer" v-if="$store.state.showSidenavFooter">
    <sidenav-card :class="cardBg" textPrimary="Need Help?" textSecondary="Please check our docs" />
  </div>
</template>
<script>
import SidenavItem from "./SidenavItem.vue";
import SidenavCard from "./SidenavCard.vue";
import { mapGetters } from "vuex";

export default {
  name: "SidenavList",
  props: {
    cardBg: String
  },
  data() {
    return {
      title: "سامانه جامع تیکتینگ",
      controls: "پنل مدیریتی",
      isActive: "active"
    };
  },
  components: {
    SidenavItem,
    SidenavCard
  },
  computed: {
    ...mapGetters(['getPermission']),
    isSuperAdmin() {
      return this.$store.getters.currentUser_username &&
        this.$store.getters.currentUser_username.toLowerCase() == 'superadmin';
    },
    havePermission: (_this) => (perm_code) => {
      return true;
      let index = _this.$store.getters.currentUser_list_perms.findIndex((v, i) => { return v.code == perm_code; });
      return index > -1;
    },
    newReferralNotifications() {
      return this.$store.getters.newReferralNotifications;
    },
    myTicketsNotifications() {
      return this.$store.getters.myTicketsNotifications;
    },
  },
  methods: {
    getRoute() {
      const routeArr = this.$route.path.split("/");
      return routeArr[1];
    },
    routeIsReport() {
      const routeArr = this.$route.path.split("/")[1];
      return routeArr === 'daily-report' || routeArr === 'dynamic-report';
    },
    routeIsAdmin() {
      const routeArr = this.$route.path.split("/")[1];
      return routeArr === 'users-manager' || routeArr == 'cameraSettings-manager' ||
        routeArr === 'userAccessGroup-manager';
    },
    isGroupRoute(targetGroup) {
      return this.$route.meta && this.$route.meta.group && this.$route.meta.group == targetGroup;
    },
    getPersonOrganType() {
      return this.$store.getters.currentUser_organTypeCode;
    },
    isMinistry() {
      return this.$store.getters.currentUser_isMinistry;
    },
    isUniversity() {
      return this.$store.getters.currentUser_isUniversity;
    },
    isHospital() {
      return this.$store.getters.currentUser_isHospital;
    },
    havePermThisGroup(facilityTypeCode) {
      return true;
      return this.$store.getters.currentUser_PermByParentCode(facilityTypeCode).length > 0;
    }

  }
};

</script>
